import React, {Fragment} from 'react';
import Iniciar from '../../components/iniciar';
import { InsProgressBar } from 'react-ins-progress-bar';
import Footer from '../../components/shareds/footer';

function IniciarScreen(){
    return(
        <Fragment>
            <InsProgressBar 
                height="3px"
                delay={600} 
                position="top"
                colors={`
                    #dc3545 15%,
                    #dc3545 15%,
                    #dc3545 12%,
                    #dc3545 32%,
                    #dc3545 35%,
                    #dc3545 55%,
                    #dc3545 59%,
                    #dc3545 63%,
                    #dc3545 92%`
                }
            />
           <Iniciar/>
           <Footer />
        </Fragment>
    );
}

export default IniciarScreen;